var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper-page"},[_c('Header',{attrs:{"hideSearch":true}}),_c('main',{staticClass:"container"},[_c('ResultMessage',{attrs:{"image":404,"message":"A url digitada não foi encontrada ou é inválida."}}),_c('Link',{on:{"click":_vm.goHome}},[_vm._v(" Voltar para página inicial ")])],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }